import React from "react";
import { TutorialStep } from "../../../models/TutorialState";
import TutorialContentFinished from "./TutorialContents/TutorialContentFinished";
import TutorialContent1 from "./TutorialContents/TutorialContent1";
import TutorialContentStart from "./TutorialContents/TutorialContentStart";

export default class TutorialRoomContent extends React.Component {
    constructor( props ) {
        super(props);

    }

    render() {
        return (
            <div>
                {this.props.tutorialState.currentStep === TutorialStep.Start &&
                <TutorialContentStart currentState={this.props.currentState}></TutorialContentStart>}

                {this.props.tutorialState.currentStep === TutorialStep.Step1 &&
                <TutorialContent1 currentState={this.props.currentState}></TutorialContent1>}

                {this.props.tutorialState.currentStep === TutorialStep.Finished &&
                <TutorialContentFinished currentState={this.props.currentState}></TutorialContentFinished>}
            </div>
        );
    }

}
